import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import { encryptionNewsDetail } from "@/api/php/home";
import { Toast } from "vant";
import { cheackQuery, ToBack } from "@/uitls/native";




export default /*#__PURE__*/_defineComponent({
  name: 'NewsDetail',
  setup(__props, { expose }) {
  expose();

const route = useRoute();
const router = useRouter();
let data = ref();

onMounted(() => {
  cheackQuery(route);
  if (
    route.query.id != "" &&
    route.query.id != null &&
    route.query.id != undefined
  ) {
    getdata();
  } else {
    Toast({
      message: "数据错误！",
      position: "bottom",
    });
    router.back();
  }
});

const getdata = async () => {
  let getnew = {
    id: route.query.id,
    client_channel: 4,
  };
  const res: any = await encryptionNewsDetail(getnew);
  if (res.code == 200) {
    data.value = res.data;
    console.log(data.value);
    
  }
};

const __returned__ = { route, router, data, getdata, ToBack }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})